export default "__VITE_ASSET__45b8870f__"